<ng-container *ngIf="showNotificationDialog">
    <!-- <div class="overlay"></div> -->
    <section class="notification-dialog-wrap" [class.versionV2]="viewConfigurations.useMobileViewWithTopMenu">
        <div class="notification-dialog box" id="notificationDialog" [ngClass]="{'info1' : customNotification.errorLevel == errorLevelEnum.Notification || customNotification.errorLevel == errorLevelEnum.Warning, 'danger' : customNotification.errorLevel == errorLevelEnum.Fatal || customNotification.errorType == errorType.Fatal, 'success' : customNotification.errorLevel == errorLevelEnum.Success}">
            <div class="title-wrap">
                <span class="title">{{customNotification.title}}</span>
                <span *ngIf="!showReloadButton && showCloseButton" class="close-button" (click)="closeNotificationDialog()">
                    <i class="icon icon-cross"></i>
                </span>
            </div>

            <div class="message-wrap">
                <div class="message">{{customNotification.message}}</div>
                <section class="loader-wrap" *ngIf="showSpinner">
                    <div class="text" i18n="Spinner message@@Spinner">Molimo sačekajte</div>
                    <div *ngIf="viewConfigurations.showTimerOnDialog" class="time">({{timeToAccept}})</div>
                    <div class="spinner"></div>
                </section>


                <div *ngIf="customNotification.offlineBets && customNotification.offlineBets.length > 0" class="offline-bets">
                    <div *ngFor="let offlineBet of customNotification.offlineBets; let i=index;">
                        <span>{{offlineBet.offlineBetType}}  </span>
                        <span> {{offlineBet.name}}</span>
                        <span *ngIf="offlineBet.betType !=null"> - {{offlineBet.betType}}</span>
                        <span *ngIf="offlineBet.sbv && offlineBet.sbv !=''" > ({{offlineBet.sbv}})
                          <ng-container *ngIf="!offlineBet.useSbvHandicapPipe">{{offlineBet.sbv}}</ng-container>
                            <ng-container *ngIf="offlineBet.useSbvHandicapPipe">{{offlineBet.sbv | handicapSbv}}</ng-container>
                        </span>
                        <span *ngIf="offlineBet.outcome != null" > {{offlineBet.outcome}}</span>
                    </div>
                </div>

                <div *ngIf="customNotification.restictedItems && customNotification.restictedItems.length > 0" class="offline-bets">
                    <div *ngFor="let restictedItem of customNotification.restictedItems; let i=index;">
                        <span>{{restictedItem.restrictedItemOne.entityName}}</span>
                        <span> - {{restictedItem.restrictedItemTwo.entityName}}</span>
                    </div>
                </div>

            </div>

            <div class="ticket-option" *ngIf="showReloadButton">
                <div class="btn" [ngClass]="{'outline-info' : customNotification.errorLevel == errorLevelEnum.Notification || customNotification.errorLevel == errorLevelEnum.Warning, 'outline-danger' : customNotification.errorLevel == errorLevelEnum.Fatal || customNotification.errorType == errorType.Fatal, 'outline-success' : customNotification.errorLevel == errorLevelEnum.Success}" (click)="reloadPage()" i18n="Refresh Page button@@RefreshPage">Osveži stranu</div>
            </div>
            <div class="ticket-option" *ngIf="showConfirmButtons">
                <div class="btn outline-primary f-r" (click)="acceptButtonClick()" i18n="ticket COnfirmation Ticket button@@ConfirmationTicket">ACCEPT</div>
                <div class="btn outline-primary f-l" (click)="closeNotificationDialog()" i18n="ticket Cancel Ticket button@@CancelTicket">DECLINE</div>
            </div>
            <div class="ticket-option" *ngIf="showLinkButton">
                <div class="btn" [ngClass]="{'outline-info' : customNotification.errorLevel == errorLevelEnum.Notification || customNotification.errorLevel == errorLevelEnum.Warning, 'outline-danger' : customNotification.errorLevel == errorLevelEnum.Fatal || customNotification.errorType == errorType.Fatal, 'outline-success' : customNotification.errorLevel == errorLevelEnum.Success}" (click)="changeLink(customNotification.link)">OK</div>
            </div>
            <div class="ticket-option" *ngIf="!showReloadButton && showCloseButton && !showLinkButton" >
                <div class="btn outline-info f-l" *ngIf="showMyTicketsButton" (click)="openMyTickets()" i18n="ticket myTicketsTab  title@@myTicketsTab">Moji lictići</div>

                <div class="btn" [ngClass]="{'outline-info' : customNotification.errorLevel == errorLevelEnum.Notification || customNotification.errorLevel == errorLevelEnum.Warning, 'outline-danger' : customNotification.errorLevel == errorLevelEnum.Fatal || customNotification.errorType == errorType.Fatal, 'outline-success' : customNotification.errorLevel == errorLevelEnum.Success}" (click)="closeNotificationDialog()">OK</div>
            </div>
        </div>



    </section>
</ng-container>
